import Layout from "@/components/feature/Layout";

const values = [
  { icon: "ri-shield-check-line", title: "Güven", desc: "Her adımda şeffaf ve güvenilir hizmet anlayışı." },
  { icon: "ri-sparkling-line", title: "Hijyen", desc: "Yaşam alanlarınızda sağlıklı ve temiz ortamlar." },
  { icon: "ri-time-line", title: "Zamanında hizmet", desc: "Randevuya uygun, planlı ve aksatmayan hizmet." },
  { icon: "ri-team-line", title: "Profesyonel ekip", desc: "Deneyimli, eğitimli ve disiplinli çalışma arkadaşları." },
  { icon: "ri-award-line", title: "Kaliteli çözümler", desc: "Her alana uygun, etkili ve sürdürülebilir temizlik planları." },
  { icon: "ri-emotion-happy-line", title: "Müşteri memnuniyeti", desc: "Sizin memnuniyetiniz bizim önceliğimizdir." },
];

export default function KurumsalPage() {
  return (
    <Layout>
      <section className="relative min-h-[360px] md:min-h-[420px] flex items-center">
        <div className="absolute inset-0">
          <img
            src="/assets/images/kurumsal-hero.jpg"
            alt="Day Temizlik Adana hakkında"
            className="w-full h-full object-cover opacity-20"
          />
          <div className="absolute inset-0" style={{ background: 'linear-gradient(90deg, rgba(3, 27, 63, 0.85), rgba(3, 27, 63, 0.45))' }}></div>
        </div>
        <div className="relative z-10 w-full px-4 md:px-6 lg:px-10 py-14 md:py-20">
          <div className="max-w-3xl">
            <span className="inline-block bg-accent-500/90 text-background-50 text-xs font-medium px-3 py-1.5 rounded-full mb-4">
              Kurumsal
            </span>
            <h1 className="font-heading text-3xl md:text-4xl font-bold text-background-50 leading-tight mb-4">
              Day Temizlik Adana hakkında
            </h1>
            <p className="text-base md:text-lg text-white leading-relaxed mb-6">
              Yaşam alanlarınızda hijyen, düzen ve güvenilir hizmet anlayışını bir araya getiren profesyonel temizlik firması.
            </p>
          </div>
        </div>
      </section>

      <section className="py-14 md:py-20 bg-background-50">
        <div className="w-full px-4 md:px-6 lg:px-10">
          <div className="max-w-4xl mx-auto">
            <p className="text-sm md:text-base text-foreground-600 leading-relaxed mb-10">
              Day Temizlik Adana, yaşam alanlarınızda hijyen, düzen ve konforu bir araya getiren profesyonel temizlik firmasıdır. Daire temizliği, bina ve site temizliği, inşaat sonrası temizlik, apartman ve site yönetimi, koltuk yıkama, halı yıkama, kuru temizleme ve ilaçlama hizmetlerinde çözüm odaklı yaklaşım sunar. Sarıçam ve Adana genelinde hızlı, güvenilir ve planlı hizmet anlayışıyla çalışıyoruz.
            </p>

            <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-10">
              <div className="bg-background-100 rounded-lg p-6 border border-background-200/50">
                <h2 className="font-heading text-xl font-bold text-foreground-950 mb-3">Misyon</h2>
                <p className="text-sm text-foreground-600 leading-relaxed">
                  Yaşam alanlarını daha temiz, sağlıklı ve düzenli hale getiren güvenilir hizmetler sunmak.
                </p>
              </div>
              <div className="bg-background-100 rounded-lg p-6 border border-background-200/50">
                <h2 className="font-heading text-xl font-bold text-foreground-950 mb-3">Vizyon</h2>
                <p className="text-sm text-foreground-600 leading-relaxed">
                  Adana'da temizlik ve yönetim hizmetlerinde güven, kalite ve müşteri memnuniyetiyle öne çıkan marka olmak.
                </p>
              </div>
            </div>

            <div className="mb-10">
              <h2 className="font-heading text-xl md:text-2xl font-bold text-foreground-950 mb-4">
                Değerlerimiz
              </h2>
              <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
                {values.map((value) => (
                  <div key={value.title} className="bg-background-100 rounded-lg p-5 border border-background-200/50">
                    <div className="w-10 h-10 flex items-center justify-center bg-accent-100/80 rounded-lg mb-3">
                      <i className={`${value.icon} w-5 h-5 flex items-center justify-center text-accent-500`}></i>
                    </div>
                    <h3 className="font-heading text-sm font-semibold text-foreground-950 mb-1">{value.title}</h3>
                    <p className="text-xs text-foreground-600">{value.desc}</p>
                  </div>
                ))}
              </div>
            </div>

            <div className="bg-primary-50 rounded-lg p-6 md:p-8 border border-primary-100">
              <h2 className="font-heading text-xl md:text-2xl font-bold text-foreground-950 mb-3">
                Day Temizlik Adana ile tanışın
              </h2>
              <p className="text-sm text-foreground-600 mb-4">
                Profesyonel temizlik ve yönetim hizmetlerimiz hakkında detaylı bilgi almak için bize ulaşın.
              </p>
              <div className="flex flex-col sm:flex-row gap-3">
                <a href="tel:05539591940" className="inline-flex items-center justify-center gap-2 bg-primary-500 text-background-50 px-5 py-3 rounded-md text-sm font-medium hover:bg-primary-600 transition-colors whitespace-nowrap">
                  <i className="ri-phone-line w-4 h-4 flex items-center justify-center"></i>
                  Hemen ara
                </a>
                <a href="https://wa.me/905539591940" target="_blank" rel="noopener noreferrer" className="inline-flex items-center justify-center gap-2 bg-accent-500 text-background-50 px-5 py-3 rounded-md text-sm font-medium hover:bg-accent-600 transition-colors whitespace-nowrap">
                  <i className="ri-whatsapp-line w-4 h-4 flex items-center justify-center"></i>
                  WhatsApp'tan Yaz
                </a>
              </div>
            </div>
          </div>
        </div>
      </section>
    </Layout>
  );
}
